import { gql } from '@apollo/client';

export const GET_RADIO_SCENARIO_EXPORT = gql`
  query RadioScenarioExport($month: Int!, $year: Int!) {
    radioScenarioExport(month: $month, year: $year) {
      fileName
      mainData {
        programTitle
        department
        month
        date
        channel
        timeSlot
        broadcastTime
        broadcastType
        radioTitle
        radioSlug
        scenarioFile
        scenarioFileName
        mp3File
        md5
        categorySlug
      }
      programs {
        index
        title
        categorySlug
      }
      programsMissingDepartment
    }
  }
`;

export const GET_BROADCAST_SCHEDULES = gql`
  query BroadcastSchedules(
    $skip: Int
    $take: Int
    $order: [BroadcastScheduleSortInput!]
    $where: BroadcastScheduleFilterInput
  ) {
    broadcastSchedules(skip: $skip, take: $take, order: $order, where: $where) {
      totalCount
      items {
        id
        title
        fromTime
        toTime
        channel
        introduction
        broadcastDate
        isHot
        createdDate
        updatedDate
        creator {
          id
          name
        }
        updater {
          id
          name
        }
        category {
          id
          title
        }
      }
    }
  }
`;
